import { withChartLayout } from 'components/common';
import Medications from 'components/features/chart/pre-clinical-manager/medications/Medications';

const MedicationsPage = withChartLayout('Medications')(Medications);
export default MedicationsPage;
